export default __webpack_public_path__ + "static/payid-860baef51f3ee52ca56454117a04e9f5.png";